/**
 * @generated SignedSource<<a36c874aa7e2215316cdbcdb71bc28ac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_viewer">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_viewer";
};
export type PdpRespIconBubbleShare_viewer$key = {
  readonly " $data"?: PdpRespIconBubbleShare_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a851da728b4289b452f95683e0d0f023";

export default node;
